// extracted by mini-css-extract-plugin
export default {"filters-container":"t0gA","header-container":"PwHI","popover-content":"DLYV","center-column":"oGnO"};